import { render, staticRenderFns } from "./AppraisalRisk.vue?vue&type=template&id=190a68ad&"
import script from "./AppraisalRisk.vue?vue&type=script&lang=ts&"
export * from "./AppraisalRisk.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports